const normalizeRoomDesignation = value => value.replace(/[^A-Za-z0-9]/g, '').slice(0, 7);

const sanitizeRoomInput = event => {
  if (event.isComposing) return;

  const input = event.target;
  const { value, selectionStart, selectionEnd } = input;
  const normalized = normalizeRoomDesignation(value);
  if (normalized === value) return;

  input.value = normalized;
  input.setSelectionRange(
    normalizeRoomDesignation(value.slice(0, selectionStart)).length,
    normalizeRoomDesignation(value.slice(0, selectionEnd)).length,
  );
};

export default {
  mounted(input) {
    input.title = 'Maximal 7 Zeichen: A–Z, a–z und 0–9.';
    // Vor dem v-model-Listener bereinigen, damit Feld und gespeicherter Wert übereinstimmen.
    input.addEventListener('input', sanitizeRoomInput, true);
  },
  beforeUnmount(input) {
    input.removeEventListener('input', sanitizeRoomInput, true);
  },
};
